import CheckIcon from "@mui/icons-material/Check";
import { Step, StepLabel, Stepper } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { MuiBox, MuiTypography } from "..";
import { ReactComponent as Edit } from "../../assets/images/stepper-edit.svg";
import { BULK_TYPE, SummaryStatus } from "../../helpers/constants";
import { commonSiteCoreKeys } from "../../helpers/constants/siteCoreKeys";
import { getValueOrBlank } from "../../helpers/utils";
import { useSiteCore } from "../../hooks/useSiteCore";
import { bulkCreateProgramSiteCoreKeys } from "../../pages/bulkCreateProgram/siteCore/siteCoreKeys";
import { bulkActivitySiteCoreKeys } from "../../pages/createBulkActivity/siteCore/SiteCoreKeys";
import { bulkTransferSiteCoreKeys } from "../../pages/createBulkTransfer/siteCore/SiteCoreKeys";
import { siteCoreContentLoadingSelector } from "../../redux/slices/appState/appStateSelector";
import { MuiStepperWrapper } from "./MuiStepper.style";
interface StepProps {
  title: string;
}
interface MuiStepperProps {
  activeStep: number;
  steps: StepProps[];
  status?: string;
  bulkType?: string;
}

export const MuiStepper: FC<MuiStepperProps> = ({
  activeStep,
  steps,
  status = "",
  bulkType = BULK_TYPE.PROGRAM,
}) => {
  const { fetchMediaListImage } = useSiteCore();
  const siteCoreLoading = useSelector(siteCoreContentLoadingSelector);
  const [processImage, setProcessImage] = useState<any>();
  const inQueueIcon = fetchMediaListImage(
    bulkCreateProgramSiteCoreKeys.progressBar,
    bulkCreateProgramSiteCoreKeys.inQueueIcon,
    commonSiteCoreKeys.smallImage,
  );
  useEffect(() => {
    if (siteCoreLoading) return;
    if (bulkType === BULK_TYPE.PROGRAM) {
      setProcessImage(
        fetchMediaListImage(
          bulkCreateProgramSiteCoreKeys.progressBar,
          bulkCreateProgramSiteCoreKeys.processIcon,
          commonSiteCoreKeys.smallImage,
        ),
      );
    } else if (bulkType === BULK_TYPE.TRANSFER) {
      setProcessImage(
        fetchMediaListImage(
          bulkTransferSiteCoreKeys.bulkTransferStepperKeys,
          bulkTransferSiteCoreKeys.processIcon,
          commonSiteCoreKeys.smallImage,
        ),
      );
    } else if (bulkType === BULK_TYPE.ACTIVITY) {
      setProcessImage(
        fetchMediaListImage(
          bulkActivitySiteCoreKeys.bulkActivityStepperKey,
          bulkActivitySiteCoreKeys.processIcon,
          commonSiteCoreKeys.smallImage,
        ),
      );
    }
  }, [bulkType, siteCoreLoading]);

  const isProcessing = activeStep === 1 && status === SummaryStatus.PROCESSING;
  const isQueue = activeStep === 1 && status === SummaryStatus.QUEUE;
  const StepIconRenderer = (props: any) => {
    const { active, completed, icon } = props;
    if (completed) {
      return <CheckIcon className="status status-completed " />;
    }

    if (active) {
      if (isQueue) {
        return (
          <MuiBox className="status status-queue">
            <img
              src={getValueOrBlank(inQueueIcon?.ImageUrl)}
              alt={getValueOrBlank(inQueueIcon?.AltText)}
              className="process-image"
            />
          </MuiBox>
        );
      }

      if (isProcessing) {
        return (
          <MuiBox className="status status-inprogress-processing">
            <img
              src={getValueOrBlank(processImage?.ImageUrl)}
              alt={getValueOrBlank(processImage?.AltText)}
              className="process-image"
            />
          </MuiBox>
        );
      }

      return (
        <MuiBox className="status status-inprogress">
          <Edit />
        </MuiBox>
      );
    }

    return (
      <MuiTypography variant="h1Bold" className="status status-open">
        {icon}
      </MuiTypography>
    );
  };

  return (
    <MuiStepperWrapper>
      <Stepper alternativeLabel activeStep={activeStep}>
        {steps.map((step, index) => (
          <Step
            key={index}
            className={activeStep < index ? "open-step" : "completed-step"}
          >
            <StepLabel StepIconComponent={StepIconRenderer}>
              <MuiTypography
                variant="h2"
                className={
                  activeStep === index ? "label-inprogress" : "normal-label"
                }
              >
                {step.title}
              </MuiTypography>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </MuiStepperWrapper>
  );
};
